import { render, staticRenderFns } from "./ModalPriorizar.vue?vue&type=template&id=ac581dd6&scoped=true"
import script from "./ModalPriorizar.vue?vue&type=script&lang=ts"
export * from "./ModalPriorizar.vue?vue&type=script&lang=ts"
import style0 from "./ModalPriorizar.vue?vue&type=style&index=0&id=ac581dd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac581dd6",
  null
  
)

export default component.exports